/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ClaimQuestRewardResponse,
    ClaimQuestRewardResponseFromJSON,
    ClaimQuestRewardResponseToJSON,
    GetAllQuestConfigsForUserResponse,
    GetAllQuestConfigsForUserResponseFromJSON,
    GetAllQuestConfigsForUserResponseToJSON,
    GetAllQuestConfigsForUserSort,
    GetAllQuestConfigsForUserSortFromJSON,
    GetAllQuestConfigsForUserSortToJSON,
    GetQuestConfigsResponse,
    GetQuestConfigsResponseFromJSON,
    GetQuestConfigsResponseToJSON,
    GetQuestConfigsSort,
    GetQuestConfigsSortFromJSON,
    GetQuestConfigsSortToJSON,
    GetQuestLeaderboardsResponse,
    GetQuestLeaderboardsResponseFromJSON,
    GetQuestLeaderboardsResponseToJSON,
    GetQuestLeaderboardsSort,
    GetQuestLeaderboardsSortFromJSON,
    GetQuestLeaderboardsSortToJSON,
    QuestConfig,
    QuestConfigFromJSON,
    QuestConfigToJSON,
    QuestConfigBody,
    QuestConfigBodyFromJSON,
    QuestConfigBodyToJSON,
    QuestProgression,
    QuestProgressionFromJSON,
    QuestProgressionToJSON,
    SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models';

export interface ClaimQuestRewardRequest {
    id: string;
}

export interface CreateQuestConfigRequest {
    questConfigBody?: QuestConfigBody;
}

export interface DeleteQuestConfigRequest {
    id: string;
}

export interface GetAllQuestConfigsForUserRequest {
    sort?: GetAllQuestConfigsForUserSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetQuestConfigSingleRequest {
    id: string;
}

export interface GetQuestConfigsRequest {
    search?: string;
    questConfigIds?: Array<string>;
    gameId?: string;
    sort?: GetQuestConfigsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetQuestConfigsForUserRequest {
    gameId?: string;
    guildId?: string;
    challengeId?: string;
}

export interface GetQuestLeaderboardRequest {
    id: string;
    sort?: GetQuestLeaderboardsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetQuestProgressionForUserRequest {
    questConfigIds?: Array<string>;
}

export interface UpdateQuestConfigRequest {
    id: string;
    questConfigBody?: QuestConfigBody;
}

/**
 * QuestsApi - interface
 * @export
 * @interface QuestsApiInterface
 */
export interface QuestsApiInterface {
    /**
     * Claims a completed quest reward.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    claimQuestRewardRaw(requestParameters: ClaimQuestRewardRequest): Promise<runtime.ApiResponse<ClaimQuestRewardResponse>>;

    /**
     * Claims a completed quest reward.
     */
    claimQuestReward(requestParameters: ClaimQuestRewardRequest): Promise<ClaimQuestRewardResponse>;

    /**
     * Used by admins to create new quest configs.
     * @param {QuestConfigBody} [questConfigBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    createQuestConfigRaw(requestParameters: CreateQuestConfigRequest): Promise<runtime.ApiResponse<QuestConfig>>;

    /**
     * Used by admins to create new quest configs.
     */
    createQuestConfig(requestParameters: CreateQuestConfigRequest): Promise<QuestConfig>;

    /**
     * Used by admins to delete existing quest configs.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    deleteQuestConfigRaw(requestParameters: DeleteQuestConfigRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by admins to delete existing quest configs.
     */
    deleteQuestConfig(requestParameters: DeleteQuestConfigRequest): Promise<void>;

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     * @param {GetAllQuestConfigsForUserSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getAllQuestConfigsForUserRaw(requestParameters: GetAllQuestConfigsForUserRequest): Promise<runtime.ApiResponse<GetAllQuestConfigsForUserResponse>>;

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     */
    getAllQuestConfigsForUser(requestParameters: GetAllQuestConfigsForUserRequest): Promise<GetAllQuestConfigsForUserResponse>;

    /**
     * Get existing quest config.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigSingleRaw(requestParameters: GetQuestConfigSingleRequest): Promise<runtime.ApiResponse<QuestConfig>>;

    /**
     * Get existing quest config.
     */
    getQuestConfigSingle(requestParameters: GetQuestConfigSingleRequest): Promise<QuestConfig>;

    /**
     * Used to get a list of all quest configs
     * @param {string} [search] 
     * @param {Array<string>} [questConfigIds] 
     * @param {string} [gameId] 
     * @param {GetQuestConfigsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsRaw(requestParameters: GetQuestConfigsRequest): Promise<runtime.ApiResponse<GetQuestConfigsResponse>>;

    /**
     * Used to get a list of all quest configs
     */
    getQuestConfigs(requestParameters: GetQuestConfigsRequest): Promise<GetQuestConfigsResponse>;

    /**
     * Used to get a list of qualified quest configs for specific game and user.
     * @param {string} [gameId] 
     * @param {string} [guildId] 
     * @param {string} [challengeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestConfigsForUserRaw(requestParameters: GetQuestConfigsForUserRequest): Promise<runtime.ApiResponse<Array<QuestConfig>>>;

    /**
     * Used to get a list of qualified quest configs for specific game and user.
     */
    getQuestConfigsForUser(requestParameters: GetQuestConfigsForUserRequest): Promise<Array<QuestConfig>>;

    /**
     * Used to get quest progress for specific quest and user.
     * @param {string} id 
     * @param {GetQuestLeaderboardsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestLeaderboardRaw(requestParameters: GetQuestLeaderboardRequest): Promise<runtime.ApiResponse<GetQuestLeaderboardsResponse>>;

    /**
     * Used to get quest progress for specific quest and user.
     */
    getQuestLeaderboard(requestParameters: GetQuestLeaderboardRequest): Promise<GetQuestLeaderboardsResponse>;

    /**
     * Used to get quest progress for specific quest and user.
     * @param {Array<string>} [questConfigIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    getQuestProgressionForUserRaw(requestParameters: GetQuestProgressionForUserRequest): Promise<runtime.ApiResponse<Array<QuestProgression>>>;

    /**
     * Used to get quest progress for specific quest and user.
     */
    getQuestProgressionForUser(requestParameters: GetQuestProgressionForUserRequest): Promise<Array<QuestProgression>>;

    /**
     * Used by admins to update existing quest configs.
     * @param {string} id 
     * @param {QuestConfigBody} [questConfigBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestsApiInterface
     */
    updateQuestConfigRaw(requestParameters: UpdateQuestConfigRequest): Promise<runtime.ApiResponse<QuestConfig>>;

    /**
     * Used by admins to update existing quest configs.
     */
    updateQuestConfig(requestParameters: UpdateQuestConfigRequest): Promise<QuestConfig>;

}

/**
 * no description
 */
export class QuestsApi extends runtime.BaseAPI implements QuestsApiInterface {

    /**
     * Claims a completed quest reward.
     */
    async claimQuestRewardRaw(requestParameters: ClaimQuestRewardRequest): Promise<runtime.ApiResponse<ClaimQuestRewardResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling claimQuestReward.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs/{id}/claim-reward`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimQuestRewardResponseFromJSON(jsonValue));
    }

    /**
     * Claims a completed quest reward.
     */
    async claimQuestReward(requestParameters: ClaimQuestRewardRequest): Promise<ClaimQuestRewardResponse> {
        const response = await this.claimQuestRewardRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by admins to create new quest configs.
     */
    async createQuestConfigRaw(requestParameters: CreateQuestConfigRequest): Promise<runtime.ApiResponse<QuestConfig>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuestConfigBodyToJSON(requestParameters.questConfigBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigFromJSON(jsonValue));
    }

    /**
     * Used by admins to create new quest configs.
     */
    async createQuestConfig(requestParameters: CreateQuestConfigRequest): Promise<QuestConfig> {
        const response = await this.createQuestConfigRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by admins to delete existing quest configs.
     */
    async deleteQuestConfigRaw(requestParameters: DeleteQuestConfigRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteQuestConfig.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by admins to delete existing quest configs.
     */
    async deleteQuestConfig(requestParameters: DeleteQuestConfigRequest): Promise<void> {
        await this.deleteQuestConfigRaw(requestParameters);
    }

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     */
    async getAllQuestConfigsForUserRaw(requestParameters: GetAllQuestConfigsForUserRequest): Promise<runtime.ApiResponse<GetAllQuestConfigsForUserResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Optional", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs/user/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllQuestConfigsForUserResponseFromJSON(jsonValue));
    }

    /**
     * Used to get all qualified quest configs across all games for the user. Specifically for Quest Progress Card \"All Games\" functionality.
     */
    async getAllQuestConfigsForUser(requestParameters: GetAllQuestConfigsForUserRequest): Promise<GetAllQuestConfigsForUserResponse> {
        const response = await this.getAllQuestConfigsForUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get existing quest config.
     */
    async getQuestConfigSingleRaw(requestParameters: GetQuestConfigSingleRequest): Promise<runtime.ApiResponse<QuestConfig>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getQuestConfigSingle.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/quest-configs/{id}/single`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigFromJSON(jsonValue));
    }

    /**
     * Get existing quest config.
     */
    async getQuestConfigSingle(requestParameters: GetQuestConfigSingleRequest): Promise<QuestConfig> {
        const response = await this.getQuestConfigSingleRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to get a list of all quest configs
     */
    async getQuestConfigsRaw(requestParameters: GetQuestConfigsRequest): Promise<runtime.ApiResponse<GetQuestConfigsResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.questConfigIds) {
            queryParameters['questConfigIds'] = requestParameters.questConfigIds;
        }

        if (requestParameters.gameId !== undefined) {
            queryParameters['gameId'] = requestParameters.gameId;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestConfigsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of all quest configs
     */
    async getQuestConfigs(requestParameters: GetQuestConfigsRequest): Promise<GetQuestConfigsResponse> {
        const response = await this.getQuestConfigsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to get a list of qualified quest configs for specific game and user.
     */
    async getQuestConfigsForUserRaw(requestParameters: GetQuestConfigsForUserRequest): Promise<runtime.ApiResponse<Array<QuestConfig>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.gameId !== undefined) {
            queryParameters['gameId'] = requestParameters.gameId;
        }

        if (requestParameters.guildId !== undefined) {
            queryParameters['guildId'] = requestParameters.guildId;
        }

        if (requestParameters.challengeId !== undefined) {
            queryParameters['challengeId'] = requestParameters.challengeId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Optional", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestConfigFromJSON));
    }

    /**
     * Used to get a list of qualified quest configs for specific game and user.
     */
    async getQuestConfigsForUser(requestParameters: GetQuestConfigsForUserRequest): Promise<Array<QuestConfig>> {
        const response = await this.getQuestConfigsForUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestLeaderboardRaw(requestParameters: GetQuestLeaderboardRequest): Promise<runtime.ApiResponse<GetQuestLeaderboardsResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getQuestLeaderboard.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.numberOfAvailableOffsets !== undefined) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters.numberOfAvailableOffsets;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/quest-configs/{id}/leaderboard`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetQuestLeaderboardsResponseFromJSON(jsonValue));
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestLeaderboard(requestParameters: GetQuestLeaderboardRequest): Promise<GetQuestLeaderboardsResponse> {
        const response = await this.getQuestLeaderboardRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestProgressionForUserRaw(requestParameters: GetQuestProgressionForUserRequest): Promise<runtime.ApiResponse<Array<QuestProgression>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.questConfigIds) {
            queryParameters['questConfigIds'] = requestParameters.questConfigIds;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-progression`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(QuestProgressionFromJSON));
    }

    /**
     * Used to get quest progress for specific quest and user.
     */
    async getQuestProgressionForUser(requestParameters: GetQuestProgressionForUserRequest): Promise<Array<QuestProgression>> {
        const response = await this.getQuestProgressionForUserRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by admins to update existing quest configs.
     */
    async updateQuestConfigRaw(requestParameters: UpdateQuestConfigRequest): Promise<runtime.ApiResponse<QuestConfig>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateQuestConfig.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("Admin", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/quest-configs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuestConfigBodyToJSON(requestParameters.questConfigBody),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => QuestConfigFromJSON(jsonValue));
    }

    /**
     * Used by admins to update existing quest configs.
     */
    async updateQuestConfig(requestParameters: UpdateQuestConfigRequest): Promise<QuestConfig> {
        const response = await this.updateQuestConfigRaw(requestParameters);
        return await response.value();
    }

}
